const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Použijte chytrý telefon',
	'blockedByDevice.paragraph.first': 'Tento odkaz lze otevřít pouze v chytrém telefonu.',
	'blockedByDevice.paragraph.second':
		'Rychlý tip: Při otevření odkazu buďte v blízkosti vozidla a mějte připravené potřebné doklady.',
	'button.continue': 'Pokračovat',
	'button.next': 'Pokračovat',
	'review.button.next': 'Dokončit',
	'button.photo.take': 'Vyfoťte',
	'onboardingStart.headline': 'Dobrý den! Pokud jste u svého vozidla, můžeme začít.',
	'onboardingStart.plateNumber': 'SPZ:',
	'onboardingStart.damageNumber': 'Číslo pojistky:',
	'onboardingStart.timeout': 'Tento odkaz bude aktivní do ',
	'button.start': 'Začít',
	poweredBy: 'Poskytováno společností <ce>ControlExpert</ce>, členem skupiny <solvd>Solvd</solvd>',
	'onboarding.headline': 'Jste připraveni začít s prohlídkou vozidla?',
	'onboarding.paragraph': 'Než začnete, prosíme, zkontrolujte následující:',
	'onboarding.documents': 'Mějte u sebe klíče/ovladače k vozidlu.',
	'onboarding.camera': 'Fotografie musí být pořízeny přes chytrý telefon.',
	'onboarding.internet':
		'Foťte na dobře osvětleném místě a s dostatečným internetovým připojením nebo daty v telefonu.',
	'onboarding.vehicle':
		'Ujistěte se, že je vozidlo čisté, přístupné ze všech stran a že jsou všechna okna zavřená.',
	'onboarding.terms.before': 'Před zahájením prosím potvrďte následující:',
	'onboarding.terms.url': 'Souhlasím s podmínkami používání.',
	'vehicleFrontLeftPerspectiveImage.title': 'Fotografie levého předoboku',
	'vehicleFrontLeftPerspectiveImage.description':
		'Vyfoťte vozidlo z předního levého rohu tak, aby bylo celé vozidlo vidět na fotografii a byla čitelná registrační značka (pokud ji vozidlo má).',
	'vehicleRearLeftPerspectiveImage.title': 'Fotografie levého zadoboku',
	'vehicleRearLeftPerspectiveImage.description':
		'Vyfoťte vozidlo ze zadního levého rohu tak, aby bylo celé vozidlo vidět na fotografii a byla čitelná registrační značka (pokud ji vozidlo má).',
	'vehicleRearRightPerspectiveImage.title': 'Fotografie pravého zadoboku',
	'vehicleRearRightPerspectiveImage.description':
		'Vyfoťte vozidlo ze zadního pravého rohu tak, aby bylo celé vozidlo vidět na fotografii a byla čitelná registrační značka (pokud ji vozidlo má).',
	'vehicleFrontRightPerspectiveImage.title': 'Fotografie pravého předoboku',
	'vehicleFrontRightPerspectiveImage.description':
		'Vyfoťte vozidlo z předního pravého rohu tak, aby bylo celé vozidlo vidět na fotografii a byla čitelná registrační značka (pokud ji vozidlo má).',
	'windshieldImage.title': 'Fotografie čelního skla',
	'windshieldImage.description':
		'Vyfoťte čelní sklo tak, aby bylo na fotografii vidět celé a všechny detaily byly dobře čitelné.',
	'vinPicture.title': 'Fotografie VIN vozidla',
	'vinPicture.description': 'Vyfoťte detail VIN tak, aby byly všechny znaky dobře čitelné.',
	'button.hint': 'Kde naleznu VIN vozidla?',
	'photo.deleteConfirmation.title': 'Opravdu chcete fotografii smazat?',
	'photo.deleteConfirmation.description':
		'Pokud fotografii smažete, budete požádáni o pořízení nové.',
	'photo.deleteConfirmation.cancel': 'Zrušit',
	'photo.deleteConfirmation.confirm': 'Smazat fotografii',
	'hint.vin.title': 'Možná umístění VIN',
	'hint.vin.description': 'VIN obvykle naleznete na jednom z následujících míst:',
	'hint.vin.location1': 'na palubní desce na straně řidiče, viditelné přes čelní sklo,',
	'hint.vin.location2': 'na rámu dveří řidiče v blízkosti zámku,',
	'hint.vin.location3': 'v motorovém prostoru, často na kovovém štítku,',
	'hint.vin.location4': 'na přední části rámu vozidla (zejména u starších vozidel).',
	'overallDashboardImage.title': 'Celková přístrojová deska vozidla',
	'overallDashboardImage.description':
		'Vyfoťte celou přístrojovou desku tak, aby byly na fotografii dobře viditelné všechny ovládací prvky a vybavení vozidla.',
	'dashboardMileage.title': 'Fotografie stavu tachometru',
	'vehicleMileage.description':
		'Vyfoťte tachometr tak, aby byl údaj o počtu najetých kilometrů dobře zaostřený a zcela čitelný.',
	'dashboardMileage.paragraph.first': 'Zapište stav tachometru vozidla.',
	'dashboardMileage.placeholder.updated': 'Počet kilometrů (km):',
	'thanks.headline.first': 'Fotografie jsme úspěšně přijaly!',
	'thankYou.message': 'Váš požadavek je zpracováván naším technickým týmem.',
	'feedback.title': 'Budeme rádi za vaši zpětnou vazbu.',
	'feedback.message':
		'Jak byste na škále od 0 do 5 ohodnotili svou zkušenost s digitální prohlídkou vozidla?',
	'feedback.helpImprove': 'Pomozte nám zlepšovat naše služby (volitelné):',
	'feedback.button.send': 'Odeslat hodnocení',
	'feedback.error.maxLength': 'Zpětná vazba nesmí přesáhnout 500 znaků.',
	'review.title': 'Souhrn vaší digitální prohlídky',
	'review.paragraph.first':
		'Před dokončením prosím zkontrolujte, že jsou všechny zadané údaje správné.<br/><br/>Po kliknutí na tlačítko „Dokončit“ ověříme vaše fotografie a zadané informace.',
	'review.stepDescription.questions': 'Údaje o vozidle',
	'review.stepDescription.group.perspectiveImages': 'Fotografie vozidla',
	'review.stepDescription.group.additionalImages': 'Doplňující fotografie',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Fotografie levého předoboku',
	'review.stepDescription.vehicleRearLeftPerspective': 'Fotografie levého zadoboku',
	'review.stepDescription.vehicleRearRightPerspective': 'Fotografie pravého zadoboku',
	'review.stepDescription.vehicleFrontRightPerspective': 'Fotografie pravého předoboku',
	'review.stepDescription.windshield': 'Fotografie čelního skla',
	'review.stepDescription.vinPicture': 'Fotografie VIN vozidla',
	'review.stepDescription.overallDashboard': 'Celková přístrojová deska vozidla',
	'review.stepDescription.mileage': 'Fotografie stavu tachometru',
	'timeout.headline.first': 'Platnost odkazu vypršela.',
	'timeout.paragraph.first': 'Volejte prosím +420 241 170 000',
	'photoUploading.title': 'Nahráváme',
	'photoAnalyzing.title': 'Probíhá zpracování',
	'photoLoading.title': 'Načítáme',
	'camera.darkWarning':
		'Fotografie je příliš tmavá. Pro lepší kvalitu prosím zajistěte lepší osvětlení.',
	'landscapeModeDetected.title': 'Automatické otáčení je zapnuto',
	'landscapeModeDetected.text':
		'Pro lepší používání fotoaparátu doporučujeme na vašem zařízení vypnout automatické otáčení obrazovky.',
	'validationContainer.correct': 'OK',
	'button.changeImage': 'Poříďte fotografii znovu',
	'button.acceptImage': 'Použít tuto fotografii',
	'button.acceptMileage': 'OK',
	'button.anotherImage': 'Pořiďte novou fotografii',
	'invalidFile.size.title': 'Nesprávná velikost fotografie',
	'invalidFile.size.description': 'Velikost fotografie překračuje maximální povolený limit.',
	'invalidFile.extension.title': 'Nepodporovaný formát souboru',
	'invalidFile.extension.description':
		'Zvolený formát souboru není podporován. Podporované formáty jsou: .jpg, .jpeg, .jfif, .heic, .heif, .png a .bmp.',
	'connectionError.title': 'Chyba připojení',
	'connectionError.description': 'Došlo k chybě připojení. Nahrajte prosím fotografii znovu.',
	'missingPhoto.title': 'Chybějící fotografie',
	'missingPhoto.description':
		'Zdá se, že chybí některá fotografie. Pro pokračování prosím nahrajte chybějící fotografii.',
};

export default messages;
